import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { IoIosFunnel, IoIosCloseCircleOutline } from "react-icons/io";
import { OutsideClick } from "../../../";
import { createPortal } from "react-dom";
import "./CheckboxFilterBox.scss";
import { useSelectiveEffect } from "../../../../custom_hooks/useSelectiveEffect";
import { deepEqual as Compare_deepEqual } from "../../../../custom_hooks/deepEqual";
import { useTransition } from "react";
import { GiConsoleController } from "react-icons/gi";

const generateSortedUniqueItems = (data, field) => {
  const map = new Map();
  data?.forEach((item) => {
    const itemValue = item[field] ? item[field].toString() : " Null";
    map.set(itemValue, (map.get(itemValue) || 0) + 1);
  });
  const itemsArray = Array.from(map, ([item, count]) => [item, count]);
  // itemsArray.sort((a, b) => b[1] - a[1]); // Sort by count in descending order
  return itemsArray;
};
const CheckboxFilterBox = (props) => {
  const {
    field,
    tableData,
    setTableData,
    data,
    filters,
    setFilters,
    AppliedFilter,
    setAppliedFilter,
    Tab,
    SetDataChenged,
    DataChanged,
  } = props;
  const [filterPosition, setFilterPosition] = useState("left");
  const [popupPos, setPopupPos] = useState({ x: 0, y: 0 });
  const [showFilters, setShowFilters] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const formRef = useRef(null);
  const searchTimeoutRef = useRef(null);
  // Store original item arrays
  const originalUniqueItemsRef = useRef([]);
  // Stateful unique items for display
  const AppliedUniqueItemsRef = useRef([]);
  const [uniqueItems, setUniqueItems] = useState([]);
  const [appuniqueItems, setappUniqueItems] = useState([]);
  const [isAnyOptionSelected, setIsAnyOptionSelected] = useState(false);
  const [Fielddata, SetFieldData] = useState(null);
  const [searchValue, setSearchValue] = useState(null);
  const [selectAll, setSelectAll] = useState(false); // Tracks if "Select All" is checked.
  const [isPending, startTransition] = useTransition();

  // Function to update 'isAnyOptionSelected' based on the current filters
  const updateIsAnyOptionSelected = useCallback(() => {
    const anySelected = filters[field]?.length > 0;
    setIsAnyOptionSelected(anySelected);
  }, [filters, field]);
  // Call this function whenever 'filters' changes to update 'isAnyOptionSelected'
  useEffect(() => {
    updateIsAnyOptionSelected();
  }, [updateIsAnyOptionSelected]);
  useSelectiveEffect(
    () => {
      const timer = setTimeout(() => {
        const valuesArray = DataChanged ? data : tableData;
        if (filters[field]?.length) {
          const Tdata = [...valuesArray]?.filter((item, index) => {
            let fieldValue = item[field] || " Null";
            return filters[field].includes(fieldValue.toString());
          });
          if (Tdata) {
            if (!Compare_deepEqual(Tdata, tableData)) {
              setTableData(Tdata);
            }
            if (!isActive) setIsActive(true);
          }
          SetDataChenged(false);
        }
      }, 100); // Set timeout for 1.2 seconds (1200 milliseconds)
      return () => clearTimeout(timer); // Clear the timeout if the component unmounts or the dependencies change
    },
    [data, field, DataChanged, tableData],
    [filters]
  );
  // Update this useEffect to correctly set uniqueItems based on tableData
  useEffect(() => {
    const itemsArray = generateSortedUniqueItems(tableData, field);
    if (itemsArray.length < 1000) {
      setUniqueItems(itemsArray);
    } else {
      const udata = itemsArray.slice(0, 1000);
      setUniqueItems(udata);
    }
    originalUniqueItemsRef.current = itemsArray; // Store the original list in a ref
  }, [tableData, field]);
  useEffect(() => {
    const itemsArray = generateSortedUniqueItems(data, field);
    if (itemsArray.length < 1000) {
      setappUniqueItems(itemsArray);
    } else {
      const udata = itemsArray.slice(0, 1000);
      setappUniqueItems(udata);
    }
    AppliedUniqueItemsRef.current = itemsArray; // Store the original list in a ref
  }, [data, field]);
  const handleFilterSubmit = useCallback(() => {
    if (!AppliedFilter.includes(field)) {
      setAppliedFilter([...AppliedFilter, field]);
    }
    if (filters[field].length) {
      let Originaldata = field === AppliedFilter[0] ? data : tableData;
      const Tdata = [...Originaldata].filter((item) => {
        let fieldValue = item[field];

        // Convert undefined or null to " Null", otherwise stringify other values including booleans
        if (fieldValue === undefined || fieldValue === null || fieldValue === false || fieldValue === "") {
          fieldValue = " Null";
        } else if (typeof fieldValue === "boolean") {
          fieldValue = fieldValue.toString();
        } else if (typeof fieldValue !== "string") {
          fieldValue = fieldValue.toString();
        }
        // For non-null values, use the string form for comparison
        return filters[field].includes(fieldValue);
      });

      if (Tdata.length > 0) {
        setTableData(Tdata);
        setIsActive(true);
      } else {
        setTableData(tableData);
      }
      setShowFilters((prev) => !prev);
      const fdata = originalUniqueItemsRef.current;
      setUniqueItems(fdata.length > 1000 ? fdata.slice(0, 1000) : fdata);
      const fdata1 = AppliedUniqueItemsRef.current;
      setappUniqueItems(fdata1.length > 1000 ? fdata1.slice(0, 1000) : fdata1);
    }
  }, [filters, tableData, field, setIsActive, setTableData, setShowFilters, setUniqueItems]);
  const handleFilterReset = useCallback(() => {
    if (AppliedFilter.includes(field)) {
      const UP_AppliedFilter = AppliedFilter.filter((ele) => ele !== field);
      setAppliedFilter(UP_AppliedFilter);
    }
    formRef.current.reset();

    setFilters((prevFilters) => {
      console.log(
        {
          ...prevFilters,
          [field]: [],
        },
        "prevFilter1"
      );
      return {
        ...prevFilters,
        [field]: [],
      };
    });

    const newFilters = { ...filters, [field]: [] };
    if (Object.keys(newFilters).every((key) => newFilters[key].length === 0)) {
      setTableData([...data]);
      setShowFilters((prev) => !prev);
      setIsActive(false);
      setSelectAll(false); // Reset "Select All" when filters are cleared
      return;
    }
    const resetdata = [...data].filter((item) => {
      return Object.keys(newFilters).every((key) => {
        // If the filter for this key is empty, include all items.
        if (newFilters[key].length === 0) {
          return true;
        }
        // Convert the item's field value to string, using " Null" for null or undefined values.
        const fieldValue = item[key] ? item[key].toString() : " Null";
        return newFilters[key].includes(fieldValue);
      });
    });

    setTableData(resetdata);
    setShowFilters((prev) => !prev);
    if (isActive) setIsActive(false);
    setIsAnyOptionSelected(false); // Reset 'isAnyOptionSelected' when filters are cleared
    setSelectAll(false); // Reset "Select All" when filters are cleared
    setSearchValue(null);
  }, [field, filters, tableData]);

  const handleCheckboxValue = useCallback(
    (event) => {
      const { checked, value } = event.target;
      if (value === "select-all") {
        // Handle "Select All" checkbox
        setSelectAll(checked);
        if (checked) {
          // If "Select All" is checked, select all options
          let Originaldata =
            field === AppliedFilter[0] ? AppliedUniqueItemsRef.current : originalUniqueItemsRef.current;
          if (searchValue) {
            Originaldata = Originaldata.filter(([item]) => item.toLowerCase().includes(searchValue));
          }
          console.log(
            {
              ...filters,
              [field]: Originaldata.map(([item]) => item?.toString()),
            },
            "prevFilter2"
          );
          setFilters({
            ...filters,
            [field]: Originaldata.map(([item]) => item?.toString()),
          });
        } else {
          // If "Select All" is unchecked, clear the filter
          console.log(
            {
              ...filters,
              [field]: [],
            },
            "prevFilter3"
          );
          setFilters({
            ...filters,
            [field]: [],
          });
        }
      } else {
        // Handle individual checkbox

        setFilters((prevFilters) => {
          let newFilters = [...prevFilters?.[field]];
          if (checked) {
            newFilters = [...newFilters, value];
          } else {
            newFilters = newFilters.filter((item) => item !== value);
          }

          console.log(
            {
              ...prevFilters,
              [field]: newFilters,
            },
            "prevFilter4"
          );
          return {
            ...prevFilters,
            [field]: newFilters,
          };
        });
        // Update 'selectAll' when any individual checkbox is clicked
        setSelectAll(false);
      }
    },
    [filters, setFilters, field, uniqueItems]
  );

  const handleItemSearch = useCallback((event) => {
    const searchValue = event.target.value.toLowerCase();
    event.preventDefault();
    setSearchValue(searchValue);
    // console.log(searchValue, "searchValue")
    // Clear existing timeout to reset the debounce timer
    clearTimeout(searchTimeoutRef.current);

    // Set a new timeout
    searchTimeoutRef.current = setTimeout(() => {
      startTransition(() => {
        if (!searchValue) {
          // Reset to the original list if search is cleared
          const fdata = originalUniqueItemsRef.current;
          setUniqueItems(fdata.length > 1000 ? fdata.slice(0, 1000) : fdata);
          const fdata1 = AppliedUniqueItemsRef.current;

          setappUniqueItems(fdata1.length > 1000 ? fdata1.slice(0, 1000) : fdata1);
        } else {
          // Filter based on search input
          setUniqueItems(originalUniqueItemsRef.current.filter(([item]) => item.toLowerCase().includes(searchValue)));
          setappUniqueItems(AppliedUniqueItemsRef.current.filter(([item]) => item.toLowerCase().includes(searchValue)));
        }
      });
    }, 1000); // Debounce time of 1.2 seconds
  }, []);

  const renderCheckboxes = (items) => {
    return items.map(([item, count], index) => (
      <label key={index} htmlFor={item}>
        <div style={{ maxWidth: "350px" }}>
          <input
            id={item}
            type="checkbox"
            value={item}
            onChange={handleCheckboxValue}
            checked={filters[field]?.includes(item?.toString()) || false}
          />
          {`${item} (${count})`}
        </div>
      </label>
    ));
  };

  return (
    field !== "select" && (
      <div>
        <IoIosFunnel
          className="filter-icon"
          style={{
            backgroundColor: isActive ? "#FF6358" : "",
            color: isActive ? "#FFFFFF" : "",
          }}
          size={17}
          onClick={(event) => {
            // Get the x position of the click
            const clickX = event.clientX;
            // Get the width of the viewport
            const viewportWidth = window.innerWidth;
            // Determine if the click is on the left or right side of the viewport
            const position = clickX < viewportWidth / 2 ? "right" : "left";
            // Set the position state
            setFilterPosition(position);
            // 1) get the bounding‐box of the icon
            const rect = event.currentTarget.getBoundingClientRect();
            // 2) account for any scroll offset
            const x = rect.left + window.scrollX;
            const y = rect.bottom + window.scrollY; // place dropdown _below_ icon
            setPopupPos({ x, y });
            setShowFilters((prev) => !prev);
            SetFieldData(field);
          }}
        />
        {showFilters &&
          createPortal(
            <OutsideClick setToggled={setShowFilters} className="flex-center filter-box">
              <div
                key={Tab}
                className="filter-parent-container"
                style={{
                  position: "absolute",
                  top: `${popupPos.y}px`,
                  left: `${popupPos.x}px`,
                  zIndex: 9999,
                  background: "white",
                  boxShadow: "0 2px 8px rgba(0,0,0,.2)",
                }}
              >
                <div className={`filter-container ${filterPosition}`}>
                  <IoIosCloseCircleOutline
                    className="close-icon"
                    onClick={() => {
                      setSearchValue(null);
                      setShowFilters((prev) => !prev);

                      const fdata = originalUniqueItemsRef.current;
                      setUniqueItems(fdata.length > 1000 ? fdata.slice(0, 1000) : fdata);
                      const fdata1 = AppliedUniqueItemsRef.current;
                      setappUniqueItems(fdata1.length > 1000 ? fdata1.slice(0, 1000) : fdata1);
                    }}
                    size={24}
                  />
                  <input
                    className="search-input"
                    placeholder="Search Text"
                    onChange={handleItemSearch}
                    type="search"
                    autoFocus
                  />
                  {isPending && <div className="loader-line-div" />}
                  <div>
                    <div className="checkbox-container">
                      <form ref={formRef}>
                        {/* "Select All" checkbox */}
                        <label htmlFor="select-all">
                          <div>
                            <input
                              id="select-all"
                              type="checkbox"
                              value="select-all"
                              onChange={handleCheckboxValue}
                              checked={selectAll}
                            />
                            Select All
                          </div>
                        </label>
                        {/* allUniqueItems for showing all the values  */}
                        {renderCheckboxes(Fielddata === AppliedFilter[0] ? appuniqueItems : uniqueItems)}
                      </form>
                    </div>
                    <div className="filter-button-box">
                      <button
                        type="reset"
                        onClick={handleFilterReset}
                        className={`${isAnyOptionSelected ? "clear-submit" : ""} clear-filter`}
                      >
                        Clear
                      </button>
                      <button
                        type="submit"
                        onClick={handleFilterSubmit}
                        className={`${isAnyOptionSelected ? "select-submit" : ""} submit-filter`}
                      >
                        Filter
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </OutsideClick>,

            document.body
          )}
      </div>
    )
  );
};
export default CheckboxFilterBox;
